module.exports = __webpack_public_path__ + "img/1.f69fcff7.jpg";